export function toLocalISODate(date: Date): string;
export function toLocalISODate(date: Date | null): string | null;
export function toLocalISODate(date: Date | null): string | null {
	return date ? toLocalISODateTime(date).substring(0, 10) : null;
}

function pad(num: number, digits = 2) {
	return String(num).padStart(digits, "0");
}

/**
 * Returns an ISO string (yyyy-MM-ddTHH:mm:ss.SSS) representing the local time
 * of the date object.
 *
 * @param date
 */
export function toLocalISODateTime(date: Date): string;
export function toLocalISODateTime(date: Date | null): string | null;
export function toLocalISODateTime(date: Date | null): string | null {
	return date
		? `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(
				date.getMinutes(),
			)}:${pad(date.getSeconds())}.${pad(date.getMilliseconds(), 3)}`
		: null;
}

/**
 * Converts a date object to a string compatible with input type datetime-local.
 * Will handle the UTC value of the date as if it was local, to be compatible with
 * data objects.
 *
 * If null or undefined is passed, returns an empty string.
 *
 * @param date
 */
export function toLocalDateTime(date?: Date | null): string {
	return date ? date.toISOString().substring(0, 16) : "";
}
